// extracted by css-extract-rspack-plugin
export default {"cls1":"ConfirmationModal-cls1_jYt","cls2":"ConfirmationModal-cls2_EI- ConfirmationModal-cls1_jYt"};